module.exports = __webpack_public_path__ + "media/images/rubicon_small_logo-f02aec3741e9145b1ff12fc88d395690.png";